'use client';

import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import ServicesHero from './components/ServicesHero';
import ServiceDetail from './components/ServiceDetail';
import PricingTransparency from './components/PricingTransparency';
import { useLanguage } from '@/contexts/LanguageContext';

export default function Services() {
  const { language } = useLanguage();

  return (
    <>
      <Header />
      <main className="min-h-screen">
        <ServicesHero language={language} />
        <ServiceDetail language={language} />
        <PricingTransparency language={language} />
      </main>
      <Footer />
    </>
  );
}